import { httpApi } from "@/services/http.api";
import qs from "qs";

export default {
  fetchByRecorderAndDateRange: async (recorderId, from, to) => {
    const params = {};
    if (recorderId) params.RecorderId = [recorderId];
    if (from) params.InitialTimestampFrom = from;
    if (to) params.InitialTimestampTo = to;

    const response = await httpApi.get("/context-events", {
      params,
      paramsSerializer: (p) =>
        qs.stringify(p, { arrayFormat: "repeat", encode: true }),
    });

    if (response.status === 204) return [];
    return response.data;
  },

  deleteById: async (id) => {
    return httpApi.delete(`/context-events/${id}`);
  },
};
